import Axios from 'axios';
import { useGtm } from '@gtm-support/vue2-gtm';

function getLeadAanvraag({ aanbod, subflow, page, lang }, { aanvraagId }, updatePrijzen = false) {
  const params = new URLSearchParams();
  if (aanbod) params.append('aanbod', aanbod);
  if (subflow) params.append('subflow', subflow);
  if (page) params.append('page', page);
  if (lang) params.append('lang', lang);
  if (updatePrijzen) params.append('updatePrijzen', updatePrijzen);
  params.append('api-version', '2');
  return Axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/v2/leadAanvraag/${aanvraagId}`, {
    params
  }).then(({ data }) => {
    sendGebeurtenissenToGtm(data.gebeurtenissenForGtm);
    return data;
  });
}

function getLeadAanvraagByK(k) {
  return Axios.get(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v2/leadAanvraag?k=${k}&api-version=2`
  ).then(({ data }) => {
    sendGebeurtenissenToGtm(data.gebeurtenissenForGtm);
    return data;
  });
}

function putLeadAanvraag({ aanbod, subflow, page, lang }, leadAanvraag) {
  const params = new URLSearchParams();
  if (aanbod) params.append('aanbod', aanbod);
  if (subflow) params.append('subflow', subflow);
  if (page) params.append('page', page);
  if (lang) params.append('lang', lang);

  return Axios.put(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v2/leadAanvraag/${leadAanvraag.aanvraagId}?api-version=2`,
    {
      ...leadAanvraag,
      //We don't send immutable data to the backend because changing this is not allowed
      immutableData: undefined
    },
    { params }
  ).then((response) => {
    sendGebeurtenissenToGtm(response.data.gebeurtenissenForGtm);
    return response;
  });
}

function postLeadAanvraag(
  lang,
  aanbodType,
  utmCodes,
  aanbodVersieId,
  subflowVersies,
  metrics = undefined
) {
  return Axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v2/leadAanvraag?lang=${lang}&api-version=2`,
    {
      utmCodes,
      aanbodType,
      metrics,
      aanbodVersieId,
      subflowVersies
    }
  ).then(({ data }) => {
    sendGebeurtenissenToGtm(data.gebeurtenissenForGtm);
    return data;
  });
}

function postLeadAanvraagFull(lang, leadAanvraag) {
  return Axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v2/leadAanvraag?lang=${lang}&api-version=2`,
    leadAanvraag
  );
}

function getNextPage(aanvraagId, aanbod, subflow = undefined, hervatFlow = undefined) {
  const params = new URLSearchParams();
  if (aanbod) params.append('aanbod', aanbod);
  if (subflow) params.append('subflow', subflow);
  if (hervatFlow) params.append('hervatFlow', hervatFlow);
  return Axios.get(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v1/leadAanvraag/${aanvraagId}/NextPage`,
    {
      params
    }
  ).then(({ data }) => data);
}

function postFileUpload(files, contentLocator, aanvraagId) {
  return Axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v1/Document/UploadWithSave/${aanvraagId}`,
    { DocumentsToUpload: files, ContentLocator: contentLocator }
  ).then(({ data }) => data);
}

function sendGebeurtenis(
  gebeurtenisTrigger,
  aanvraagId,
  flowview,
  page,
  subflow,
  mappedDataFromTrigger
) {
  return Axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v1/Gebeurtenis`,
    {
      gebeurtenisTrigger,
      aanvraagId,
      mappedDataFromTrigger,
      page,
      subflow,
      flowview
    },
    {
      ignoreGlobalErrorHandler: true
    }
  ).then(({ data }) => {
    if (data) {
      const gebeurtenisArray = Array(1).fill(data);
      sendGebeurtenissenToGtm(gebeurtenisArray);
    }
    return data;
  });
}

export const viewType = {
  startAanbod: 0,
  page: 1,
  overzicht: 2,
  betaalOverzicht: 3
};

function sendGebeurtenissenToGtm(gebeurtenissenForGtm) {
  const gtm = useGtm();
  if (gtm?.enabled()) {
    gebeurtenissenForGtm?.forEach((gebeurtenis) => {
      const mappedGebeurtenis = {
        correlationId: gebeurtenis.correlationId,
        correlationType: gebeurtenis.correlationType,
        data: JSON.parse(gebeurtenis.data),
        dataType: gebeurtenis.dataType,
        event: gebeurtenis.eventName,
        timestamp: gebeurtenis.timestamp
      };
      gtm.trackEvent(mappedGebeurtenis);
    });
  }
}

export default {
  getLeadAanvraag,
  getLeadAanvraagByK,
  putLeadAanvraag,
  postLeadAanvraag,
  postLeadAanvraagFull,
  getNextPage,
  postFileUpload,
  sendGebeurtenis
};
